import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useRouter } from 'next/router';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { toArray } from 'src/utils/helpers';

import styles from './_ClearAll.module.css';

type ClearAllProps = {
	searchFilterData:
		| {
				name: string;
				placeholder: string;
				data: {
					label: JSX.Element;
					value: string;
				}[];
		  }[]
		| undefined;
	text: Field<string>;
};

export function ClearAll(props: ClearAllProps): JSX.Element {
	const { getValues, setValue } = useFormContext();
	const router = useRouter();

	const disableClearAllButton = useMemo(() => {
		const someFiltersSelected = props.searchFilterData?.some((x) => toArray(getValues(x.name)).length > 0);

		return !someFiltersSelected ? { disabled: true } : '';
	}, [router]);

	const resetFilterSelections = useCallback(() => {
		props.searchFilterData?.forEach((filter) => {
			setValue(filter.name, null);
		});
	}, []);

	return (
		<button
			type="button"
			onClick={resetFilterSelections}
			className={`${styles.clearAll} link linkOffset linkHoverWeighted`}
			{...disableClearAllButton}
		>
			<Text field={props.text} />
		</button>
	);
}
